import { useState, useEffect } from 'react';
import App from './App';
import LandingPage from './LandingPage';
import { isAdminEntry } from './utils';

// `#gold` / `#silver` are the exact hash values the booking flow itself has
// always read on mount (see App.js) and written when switching farmhouses —
// treating them as "go straight to the booking flow" here means every link
// already shared on Instagram/WhatsApp keeps working byte-for-byte. Anything
// else (no hash, or the landing page's own in-page anchors like #stays/#pool)
// shows the marketing landing page instead.
//
// `#admin` or the admin.riazfarmhouse.com subdomain also route to <App/> —
// App.js itself checks the same condition to jump straight to the Admin
// Dashboard (see isAdminEntry in utils.js), skipping the landing page and
// booking flow entirely. hostname doesn't change without a full page
// reload, so it doesn't need to be tracked in state like the hash does.
function Root() {
  const [hash, setHash] = useState(window.location.hash);

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const isBookingHash = hash === '#gold' || hash === '#silver' || hash === '#admin';
  return (isBookingHash || isAdminEntry()) ? <App /> : <LandingPage />;
}

export default Root;
